import styled from 'styled-components';
import { colors, duration, easing } from 'ui/theme';
import { Cell } from './Cell';

const EditCell = styled(Cell)`
  min-height: 100%;
  align-items: flex-start;
`;

const StyledButton = styled.button`
  flex-grow: 1;
  padding: 0;
  text-align: initial;
  cursor: pointer;
  background-color: transparent;
  border: none;
  transition: all ${easing.entrance} ${duration.short};

  &:before {
    content: attr(data-placeholder);
    opacity: 0;
    color: ${colors.textSecondary};
    transition: all ${easing.entrance} ${duration.short};
  }

  &[data-value='true'] {
    &:before {
      content: '';
    }
  }

  &:hover {
    text-decoration: underline;
  }

  &[data-value='false'] {
    align-self: stretch;

    &:hover {
      font-style: itallic;
      text-decoration: none;

      &:before {
        opacity: 1;
      }
    }
  }
`;

type EditableCellProps = {
  placeholder: string;
  value: string;
  onClick: () => void;
};

export const EditableCell = ({ placeholder, value, onClick }: EditableCellProps) => {
  return (
    <EditCell data-test="editable-cell">
      <StyledButton
        data-placeholder={placeholder}
        data-value={Boolean(value).toString()}
        onClick={onClick}
      >
        {value}
      </StyledButton>
    </EditCell>
  );
};
